
import { attributeTypes, componentAttributeTypes } from "../Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue } from "../Definitions/LayoutNode";
import { ScreenSize } from "../Definitions/ScreenSize";
import { wBComponentTypeNames } from "../Definitions/WBComponentTypeNames";
import { BreakPoints } from "./BreakPoints";
import { serifFonts } from "./GenerateGlobalStyleFromSiteData";
import GetImageURLWithResolution from "./GetImageURLWithResolution";

export default function GenerateCSSTokensFromLayoutNodes( rootNode:LayoutNode,tokenPrefix:string = "",isLivePublish:boolean = false){
    

    let tokenId = 0;
    let desktopDict:{[key:string]:string} = {};
    let tabletDict:{[key:string]:string} = {};
    let mobileDict:{[key:string]:string} = {};

    resetTokenClassesRecursive(rootNode);
    processNodeRecursive(rootNode,ScreenSize.Desktop,desktopDict);
    processNodeRecursive(rootNode,ScreenSize.Tablet,tabletDict);
    processNodeRecursive(rootNode,ScreenSize.Mobile,mobileDict);

    let returnString = "";

    returnString += getInnerCSSFromTokenDictionary(desktopDict);

    if(isLivePublish){
            returnString += `@media (max-width: ${BreakPoints.Tablet}px) {\n`;
            returnString += getInnerCSSFromTokenDictionary(tabletDict);
            returnString += "}\n";

            returnString += `@media (max-width: ${BreakPoints.Mobile}px) {\n`;
            returnString += getInnerCSSFromTokenDictionary(mobileDict);
            returnString += "}\n";
    }
    else{
        returnString += getInnerCSSFromTokenDictionary(tabletDict,".tablet-break");
        returnString += getInnerCSSFromTokenDictionary(mobileDict,".mobile-break");
    }



    return returnString;

    function getInnerCSSFromTokenDictionary(dict:{[key:string]:string},preAppend = ""){

        let returnString = "";

        for(const [key,value] of Object.entries(dict)){

            returnString += preAppend +" ."+value+"{"+key+" !important;}\n"; // currently forcing important to override page.content.css
        }

        return returnString;
    }


    function resetTokenClassesRecursive(node:LayoutNode,depth:number = 0){

        node.tokenClasses = "";

        for(let i = 0;i<node.children.length;i++){

            resetTokenClassesRecursive(node.children[i],depth+1);
        }
    }

    function processNodeRecursive(node:LayoutNode,screenSize: ScreenSize,tokenDict:{[key:string]:string},depth:number = 0){

        let overlay = getNodeComponentAttributeValue(node,componentAttributeTypes.overlayColor);
        let isGradient = (overlay&& overlay.includes("gradient"));

        if(depth>254){
            console.error("Exceded Layout Depth");
            return;
        }

        
        let atts = node.screenSizeStyleAttributes[screenSize];
        if(overlay && !node.screenSizeStyleAttributes[screenSize][attributeTypes.boxShadow] && !isGradient ){
            atts = {...atts,boxShadow:"none"}; // mark the boxshadow as none so that the for loop can correctly convert to overlay
        }

        for(let [key,value] of Object.entries(atts)){
            
            if(value==" "||value.length<=0)
                continue;
       
                //combine inset shadows
            switch(key){
                 
 
                case "backgroundImage":
                 // CHECK FOR COMPRESSION level based on calculated bounds
         
                 let resolution = node.screenResolutions;
                 value = GetImageURLWithResolution(value,resolution);
           
                if(isGradient){
                    value = overlay +","+value;
                }

                break;


                case "boxShadow":
                    if(node.componentAttributes[componentAttributeTypes.overlayColor] && !isGradient ){ // if theres an overlay append it!
                        if(value=="none")
                            value = `inset 0 0 0 30000px ${node.componentAttributes[componentAttributeTypes.overlayColor]}`; // if theres no box shadow just add the inset shadow
                        else
                            value += ` ,inset 0 0 0 30000px ${node.componentAttributes[componentAttributeTypes.overlayColor]}`;

                    }
                    break;
                case "fontFamily":

                    const fallBack = serifFonts.includes(value)?"serif":"sans-serif";
                    value = `'${value}',${fallBack}`;
                    break;
                default:
                    break;

            }

            let newKey  = convertCamelCaseToDash(key)+":"+value;

            if(!tokenDict[newKey]){

                //include extra classes for padding so that columns can parse then pass the padding token to the inner container
                let prefix = "vwb-";

                if(newKey.includes("padding")){
                    prefix+="pdg-";
                }
                else if(newKey.includes("margin")){
                    prefix+="mrg-";
                }
                else if(newKey.includes("width")){
                    prefix+="wdth-";
                }
                else if(newKey.includes("height")){
                    prefix+="hght-";
                }
          

                const cls = prefix+tokenPrefix+tokenId.toString();
                //(newKey.includes("padding"))?"vwb-pdg-"+tokenPrefix+tokenId.toString():"vwb-"+tokenPrefix+tokenId.toString();
                

                tokenDict[newKey] =cls;
                node.tokenClasses += " "+cls;
                tokenId++;
            }
            else{
                node.tokenClasses += " "+tokenDict[newKey];
            }

        }

        for(let i = 0;i<node.children.length;i++){

            processNodeRecursive(node.children[i],screenSize,tokenDict,depth+1);
        }

    }

}


function convertCamelCaseToDash(property:string) {
    return property.replace(/([A-Z])/g, "-$1").toLowerCase();
}